import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'auth',

  can: {
    route() {
      return this.child && this.isEmployee();
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/EmployeePerimeter.js